export default function throwIfNotOk(r) {
	if (!r.ok) throw r
	return r
}